<template>
  <a-drawer
    :width="detailWidth"
    :title="detail.name + ' - ' + detail.id"
    placement="right"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <p class="h1">User Profile</p>
    <br />
    <a-row>
      <a-col :span="12">
        <ProfileItem1
          title="电话"
          :value="detail.house !== undefined ? detail.house.owner.phone : ''"
        />
      </a-col>
      <a-col :span="12">
        <ProfileItem1
          title="邮箱"
          :value="
            detail.house !== undefined
              ? detail.house.owner.email === undefined
                ? '未绑定'
                : detail.house.owner.email
              : ''
          "
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <ProfileItem1
          title="收纳币"
          :value="detail.house !== undefined ? detail.house.owner.coin : ''"
        />
      </a-col>
      <a-col :span="12">
        <ProfileItem1
          title="App版本"
          :value="detail.house !== undefined ? detail.house.owner.version : ''"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <ProfileItem1
          title="注册时间"
          :value="
            detail.house !== undefined
              ? this.$moment(detail.house.owner.createdAt).format(
                  'YYYY-MM-DD HH:mm:ss'
                )
              : ''
          "
        />
      </a-col>
      <a-col :span="12">
        <ProfileItem1
          title="最后登录"
          :value="
            detail.house !== undefined
              ? this.$moment(detail.house.owner.updatedAt).format(
                  'YYYY-MM-DD'
                ) +
                '(' +
                this.$moment(detail.house.owner.updatedAt).fromNow() +
                ')'
              : ''
          "
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <ProfileItem1
          title="注册时长"
          :value="
            detail.house !== undefined
              ? this.$moment(detail.house.owner.createdAt).fromNow()
              : ''
          "
        />
      </a-col>
      <a-col :span="12"> </a-col>
    </a-row>
    <a-divider />
    <p class="h1">House</p>
    <br />
    <!-- <template v-for="house in detail.houses"> </template> -->
    <UserHouseList
      v-for="house in detail.houses"
      :key="house.id"
      :house="house"
      @changeHousePlan="changeHousePlan"
    />
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button :style="{ marginRight: '8px' }" @click="onClose">
        Cancel
      </a-button>
      <a-button type="primary" @click="changeHousePlan"> Submit </a-button>
    </div>
  </a-drawer>
</template>

<script>
const AV = require("leancloud-storage");
import UserHouseList from "../../UserHouseList";
import ProfileItem1 from "../userList/ProfileItem";

export default {
  props: ["detail", "visible"],
  components: { UserHouseList, ProfileItem1 },
  data() {
    return {
      detailWidth: 640,
    };
  },
  mounted() {
    if (screen.width < 740) {
      this.detailWidth = "100%";
    } else {
      this.detailWidth = 640;
    }
  },
  methods: {
    changeHousePlan(houseId, plan, date) {
      console.log(houseId);
      console.log(plan);
      console.log(date);
    },
    afterVisibleChange(val) {
      console.log("visible", val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    selectUser(record, index) {
      return {
        on: {
          click: async () => {
            console.log(record, index);
            const result = await AV.Cloud.run("fetchAllHouse", {
              ownerId: record.id,
            });
            this.detail = {
              name: record.name,
              id: record.id,
              house: result[0],
              houses: result,
            };
            this.showDrawer();
          },
          dblclick: () => {},
        },
      };
    },
  },
};
</script>

<style>
</style>